// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/apps/shopify/:shop\",\"regex\":\"^/apps/shopify/([^/]+)$\",\"paramNames\":[\"shop\"],\"hasOptionalPrefix\":false},{\"path\":\"/customers/:id\",\"regex\":\"^/customers/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/fulfillment-providers/manual-fulfillment/:id\",\"regex\":\"^/fulfillment-providers/manual-fulfillment/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/orders/:id\",\"regex\":\"^/orders/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/products/:id\",\"regex\":\"^/products/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/shipments/:id\",\"regex\":\"^/shipments/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/warehouses/:id\",\"regex\":\"^/warehouses/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/organizations/:organizations*?\",\"regex\":\"^/organizations(?:/(.*))?$\",\"paramNames\":[\"organizations\"],\"hasOptionalPrefix\":false},{\"path\":\"/sign-in/:sign-in*?\",\"regex\":\"^/sign-in(?:/(.*))?$\",\"paramNames\":[\"sign-in\"],\"hasOptionalPrefix\":false},{\"path\":\"/sign-up/:sign-up*?\",\"regex\":\"^/sign-up(?:/(.*))?$\",\"paramNames\":[\"sign-up\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/customers\"},{\"path\":\"/fulfillment-providers\"},{\"path\":\"/fulfillment-providers/dhl-express\"},{\"path\":\"/fulfillment-providers/japan-post-international\"},{\"path\":\"/fulfillment-providers/japan-post-ugx\"},{\"path\":\"/fulfillment-providers/manual-fulfillment\"},{\"path\":\"/import-export\"},{\"path\":\"/logs\"},{\"path\":\"/orders\"},{\"path\":\"/products\"},{\"path\":\"/settings\"},{\"path\":\"/settings/api-keys\"},{\"path\":\"/settings/apps\"},{\"path\":\"/settings/billing\"},{\"path\":\"/settings/document-signatures\"},{\"path\":\"/settings/invoice-templates\"},{\"path\":\"/settings/notifications\"},{\"path\":\"/shipments\"},{\"path\":\"/shipping-rules\"},{\"path\":\"/switch-organization\"},{\"path\":\"/tools\"},{\"path\":\"/warehouses\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.11";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from "@sentry/nextjs";
import { isClerkSessionTouchNetworkError } from "@shipmate/common/clerk-error-filter";
// PostHog instrumentation
import posthog from "posthog-js";

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
  api_host: "/ingest",
  ui_host: "https://us.posthog.com",
  capture_exceptions: true, // This enables capturing exceptions using Error Tracking
  capture_pageview: false, // Pageviews are captured manually in PostHogPageView
  capture_pageleave: true, // Capture pageleave events
  person_profiles: "always", // Create profiles for anonymous users as well
  debug: false,
  // Drop transient ClerkJS session-`touch` heartbeat network failures so they
  // don't fragment into a fresh error-tracking issue per session/version.
  before_send: (event) => {
    if (
      event?.event === "$exception" &&
      isClerkSessionTouchNetworkError(event.properties?.$exception_list)
    ) {
      return null;
    }
    return event;
  },
});

Sentry.init({
  dsn: "https://8723f445d012e8cffa0641cbc98fc8a2@o511671.ingest.us.sentry.io/4508240347136000",
  enabled: process.env.NODE_ENV === "production",

  // Add optional integrations for additional features
  integrations: [Sentry.replayIntegration()],

  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
  sendDefaultPii: true,

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,
  tracePropagationTargets: ["https://api.shipmate.jp", /^\/api\//],

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  // Same transient ClerkJS session-`touch` network failures reach Sentry too —
  // drop them so they don't churn out new issues there either.
  beforeSend: (event) => {
    if (isClerkSessionTouchNetworkError(event.exception?.values)) {
      return null;
    }
    return event;
  },
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
